import {
  DataModel,
  DataModelBuilder, SerializationContext, SerializedData, cloneDataOrNull, isSameData,
} from '../dto/dto.js';
import { Address } from './address.js';
import { GeoCoordinates } from './geo-coordinates.js';
import { TimeZoneRegion } from './time-zone-region.js';
import { fromEnumAsStringOrNull, toEnumFromStringOrNull } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';

export class CustomerLocation extends DataModel {
  static readonly TYPE_ID: string = '7fe5ca048f5d4207a9e348c4701929da';

  constructor(
    public readonly address: Address | null,
    public readonly coordinates: GeoCoordinates | null,
    public readonly timezone: TimeZoneRegion | null,
  ) {
    super();
  }

  get $typeId(): string {
    return CustomerLocation.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CustomerLocation {
    return new CustomerLocation(
        context.fromDataOrNull(MapUtils.getRecordOrNull(map, 'address')),
        context.fromDataOrNull(MapUtils.getRecordOrNull(map, 'coordinates')),
        toEnumFromStringOrNull(MapUtils.getStringOrNull(map, 'timezone'), TimeZoneRegion),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'address': context.toDataOrNull(this.address),
      'coordinates': context.toDataOrNull(this.coordinates),
      'timezone': fromEnumAsStringOrNull(this.timezone),
    };
  }

  clone(): this {
    return new CustomerLocation(
        cloneDataOrNull(this.address),
        cloneDataOrNull(this.coordinates),
        this.timezone,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.address, this.address) &&
        isSameData(other.coordinates, this.coordinates) &&
        other.timezone === this.timezone;
  }
}

export class CustomerLocationBuilder extends DataModelBuilder<CustomerLocation> {
  build(context: SerializationContext, map: SerializedData): CustomerLocation {
    return CustomerLocation.fromMap(context, map);
  }
}
